import { useMediaQuery, useTheme } from '@mui/material';
import TimeLine from '../../components/Timeline/TimeLine';
import TimeLineMobile from '../../components/Timeline/TimeLineMobile';
import SEO from '../../components/SEO/SEO';

const Process = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <SEO
        title='Mudrost Studio – Expert Food & Product Photography, Videography in Bangalore'
        description='Bangalore-based expert creative team doing food and product photography, videography, and commercial storytelling from concept to final execution.'
        itempropDescription='Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.'
        keywords='food photography Bangalore, product photography Bangalore, commercial photography studio, food videography Bangalore, product videography services, ad film production Bangalore'
        url='https://mudrost.in/process'
      />
      {mobile ? <TimeLineMobile /> : <TimeLine />}
    </>
  );
};

export default Process;
